import './functions';
import './statics';
import { wrapperBuilder } from './build';

export const InAppBrowserWrapper = wrapperBuilder.build();
